import React, { createContext, useContext } from 'react';
import Request from '@hotmart/request';
import { useQuery } from '@tanstack/react-query';

import { ENTITY_TYPE } from '@/types';

type User = {
  id?: string;
  ucode?: string;
  isFromBrazil?: boolean;
  entityType?: ENTITY_TYPE;
  hasSales?: boolean;
  mei?: boolean;
};

const UserContext = createContext<User>({
  id: '',
  ucode: '',
  isFromBrazil: false,
  entityType: undefined,
  hasSales: false,
  mei: false,
});

export interface UserProviderProps {
  children: React.ReactNode;
  userData?: Omit<User, 'entityType' | 'hasSales'>
}

export const UserProvider = ({ children, userData }: UserProviderProps) => {
  const { data: sales } = useQuery({
    queryKey: ['accounts.activities.check.sales'],
    queryFn: () =>
      Request('accounts.activities.check.sales'),
    enabled: !!userData?.id,
  });

  return (
    <UserContext.Provider value={{
      ...userData,
      mei: userData?.mei || false,
      hasSales: sales?.hasSales || false,
    }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
